import Hero from "components/Hero";
import Navbar from "components/Navbar";
import NewWork from "components/NewWork";
import Profile from "components/Profile";
import Skill from "components/Skill";
import Socmed from "components/Socmed";
import { Element } from "react-scroll";

export default function Home() {
	const emailMe = () => {
		window.open("mailto:hariyannnn@gmail.com", "_blank");
	};

	return (
		<div className=" mx-auto py-10 px-5 md:px-20">
			<Navbar emailMe={emailMe} />
			<Element name="heroContainer">
				<Hero emailMe={emailMe} />
			</Element>
			<Socmed />
			<Element name="skillContainer">
				<Skill />
			</Element>
			<Element name="workContainer">
				<NewWork />
			</Element>
			<Element name="profileContainer">
				<Profile />
			</Element>
		</div>
	);
}
